import React from "react";
import ReactDomServer from "react-dom/server";
import { Footer, } from "@kmdpartners/ui-kit/src/CN_Design_System";
function App() {
    return (React.createElement("div", null,
        React.createElement(Footer, null)));
}
if (window == undefined) {
    const ssrContent = ReactDomServer.renderToString(React.createElement(App, null));
    console.log("SSR Content", ssrContent);
}
export default App;
